import PropTypes from "prop-types";
import React from "react";
import cc from "classcat";
import handleReportError from "./handleReportError";
import MaintenanceErrorPage from "./MainteinanceErrorPage";
import InternalServerErrorPage from "./InternalServerErrorPage";
import useDarkMode from "../../hooks/useDarkMode";
import NotFoundErrorPage from "./NotFoundErrorPage";
import NoInternetErrorPage from "./NoInternetErrorPage";
import { errorsTypes } from "../../hooks/useErrorMessage";
ApplicationErrorHandler.propTypes = {
    error: PropTypes.object.isRequired
};
export default function ApplicationErrorHandler(param) {
    var error = param.error;
    var darkMode = useDarkMode();
    // We can't use anything from INTL or AUTH here
    handleReportError(error);
    var isMaintenanceError = false;
    var isNotFoundError = false;
    var noInternetConnectionError = false;
    if (error.status === 503 || error.response && error.response.status === 503) {
        isMaintenanceError = true;
    }
    if (error.status === 404 || error.response && error.response.status === 404) {
        isNotFoundError = true;
    }
    /**
     * If the status is 426 it means that the user is using an outdated app version so we refresh the page
     */ if (error.status === 426 || error.response && error.response.status === 426) {
        window.location.reload();
    }
    if (error && error.message === errorsTypes.NO_INTERNET_CONNECTION_ERROR) {
        noInternetConnectionError = true;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: cc([
            "",
            {
                dark: darkMode
            }
        ])
    }, /*#__PURE__*/ React.createElement("main", {
        id: "content",
        role: "main",
        className: "grid h-screen items-center"
    }, isMaintenanceError && /*#__PURE__*/ React.createElement(MaintenanceErrorPage, null), isNotFoundError && /*#__PURE__*/ React.createElement(NotFoundErrorPage, null), noInternetConnectionError && /*#__PURE__*/ React.createElement(NoInternetErrorPage, null), !isMaintenanceError && !isNotFoundError && !noInternetConnectionError && /*#__PURE__*/ React.createElement(InternalServerErrorPage, null)));
}
